import React from 'react'; 
import Link from 'next/link';
import Image from 'next/image';
import { Card } from '@/components/ui/card';
import links from '@/lib/localEndPoints';
// Define the data structure for a single company
import { CompanyData as Company } from '@/types/companies';
import fixNewsContent from '@/lib/SVG_Render';
interface CompanyCardProps {
  company: Company;

}

export const CompanyCard: React.FC<CompanyCardProps> = React.memo(({ company }) => {

  const imageUrl = company?.media?.[0]?.url || '/default.jpg'; 

  // Determine alt text for accessibility
  const altText = `Logo or image for ${company.name || 'a company'}`;

  // Extract year for display
  const establishedYear = company?.established_date?.split("-")[2];

  return (
  
    <Link
      href={`${links.COMPANIES}/${company.slug}`}
      className="group block h-full"
    >
      <Card className="overflow-hidden h-full rounded-2xl p-0 gap-0 border-ring shadow-sm hover:bg-primary hover:text-white transition-all duration-300">
        {/* Image container */}
        <div className="relative aspect-3/2 overflow-hidden">
          <Image
            src={imageUrl}
            alt={altText}
            fill
            sizes="(max-width: 640px) 100vw, (max-width: 768px) 50vw, (max-width: 1024px) 33vw, 25vw"
            loading="lazy"
            className="object-contain transition-transform duration-300 ease-in-out bg-white group-hover:scale-110"
          />
        </div>
        {/* Content container */}
        <div className="px-5 py-4 text-left ">
          {establishedYear && ( 
            <p className="text-xs md:text-sm text-muted-foreground group-hover:text-muted ">
              Established at {establishedYear}
            </p>
          )}
          <h3 className="font-semibold text-base md:text-xl my-2">
            {company.name}
          </h3>
          {company.tagline && ( 
            <div
              className='prose text-sm leading-relaxed text-muted-foreground group-hover:text-muted flex-grow line-clamp-2'
              dangerouslySetInnerHTML={{ __html: fixNewsContent(company.tagline) }}
            />
          )}
        </div>
      </Card>
    </Link>
  );
});